// The thin rounded progress bar on the section overview: once for the whole
// test, once inside the section the student is working on.
//
// Display-only. It takes the two counts rather than a percentage so callers
// pass what they already have and cannot get the division wrong in three
// different places.

import React from "react"
import { BMD_UI } from "../../constants/diagnostics/bmd.theme"

export type BmdProgressBarProps = {
  done: number
  total: number
  height?: number
  className?: string
}

export const BmdProgressBar: React.FC<BmdProgressBarProps> = ({
  done,
  total,
  height = 6,
  className,
}) => {
  // A zero total would divide to NaN and render an invisible bar with no clue
  // why, so it is clamped to an empty one.
  const pct =
    total > 0 ? Math.min(100, Math.max(0, Math.round((done / total) * 100))) : 0

  return (
    <div
      className={className}
      style={{
        height,
        borderRadius: height,
        backgroundColor: BMD_UI.TRACK,
        overflow: "hidden",
      }}
      role="progressbar"
      aria-valuenow={done}
      aria-valuemin={0}
      aria-valuemax={total}
    >
      <div
        style={{
          width: `${pct}%`,
          height: "100%",
          borderRadius: height,
          backgroundColor: BMD_UI.FILL,
          transition: "width 220ms ease",
        }}
      ></div>
    </div>
  )
}

export default BmdProgressBar
